module.exports = __webpack_public_path__ + "img/20200515_163339.18a8f9c2.jpg";